<template>
  <div>
    <CardSlider
      cardType="ImageCard"
      :title="title"
      :generalCardLabel="$t('general.labels.interview')"
      :cards="interviewCards"
      @onCardClick="showModal"
    />

    <InterviewModal
      :show="modalContent"
      v-bind="modalContent"
      @onClose="showModal(null)"
      @onNavigate="navigateFromModal"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import CardSlider from "./CardSlider.vue";
import InterviewModal from "../general/InterviewModal.vue";

const props = defineProps({
  title: String,
  currentPage: String
});

const { t, tm, locale } = useI18n();
const modalContent = ref(null);

const interviewsPerPage = computed(() => tm("interviews"));

const interviewContents = computed(() => {
  return Object.entries(interviewsPerPage.value)
    .map(([page, cards]) =>
      cards.map((card, i) => {
        // This keeps the images correct for English, since interviews are
        // not the same between languages

        const advanceNumbers = page == "download" && locale.value == "en";
        return {
          ...card,
          interviewGradient: `var(--diag-gradient-${card.relatedPage || page})`,

          cardContent: {
            imagePath: `${t('translation.' + page)}_interviste-${i + (advanceNumbers ? 2 : 1)}`,
            internalUrlParam: card.relatedPage || (page == "download" ? props.currentPage : page),
            ...card.cardContent,
          },
        };
      })
    )
    .flat(2);
});

const interviewCards = computed(() => {
  return interviewContents.value.map((content) => content.cardContent);
});

function showModal(cardIndex) {
  modalContent.value = interviewContents.value[cardIndex];
}

function navigateFromModal() {
  if (
    modalContent.value.cardContent.internalUrlParam === props.currentPage
  ) {
    modalContent.value = null;

    // Wait until fade animation is done before scrolling
  setTimeout(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, 500)
  }
  

  
  
}
</script>

<style lang="scss" scoped></style>
